import { Trans } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage.js';
import PropTypes from 'prop-types';

/**
 * A wrapper around the Trans component that automatically re-renders when language changes
 * Use this component exactly like you would use Trans
 */
const TransWrapper = (props) => {
	const { currentLanguage } = useLanguage();

	// The key prop forces re-render when language changes
	return (
		<Trans
			key={currentLanguage}
			components={{
				bold: <span className='font-bold' />,
				underline: <span className='underline' />,
				italic: <span className='italic' />,
				strike: <span className='line-through' />,
			}}
			{...props}
		/>
	);
};

TransWrapper.propTypes = {
	i18nKey: PropTypes.string.isRequired,
	components: PropTypes.object,
};

export default TransWrapper;
